import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { RendererPropTypes } from '@/components/changeRequests/propertyRenderer'
import { FormRow } from '@/components/changeRequests/formRow'

function DualLanguageRow ({ label, latinLabel, name, latinName, hideLatinVariant, ...props }) {
  const [value, setValue] = useState()
  const [latinValue, setLatinValue] = useState()

  const validate = () => {
    return props.required ? !value && !latinValue : false
  }

  return <React.Fragment>
    <FormRow label={label} name={name} onValidate={({ value }) => { setValue(value) }} {...props} required={validate()} />
    {!hideLatinVariant && <FormRow label={latinLabel} name={latinName} onValidate={({ value }) => { setLatinValue(value) }} {...props} required={validate()} />}
  </React.Fragment>
}

DualLanguageRow.propTypes = {
  ...RendererPropTypes,
  inputType: PropTypes.oneOf(['text', 'textarea']),
  latinName: PropTypes.string,
  showLatinVariant: PropTypes.bool,
  latinLabel: PropTypes.string
}

export { DualLanguageRow }



// WEBPACK FOOTER //
// ./src/components/changeRequests/dualLanguageRow.js